import client from './client';

export const notificationKeys = {
  all: ['notifications'] as const,
  list: (filters?: { is_read?: boolean }) =>
    ['notifications', 'list', filters ?? {}] as const,
  unreadCount: ['notifications', 'unread-count'] as const,
};

export interface CenterNotification {
  id: number;
  type: string;
  title: string;
  body: string | null;
  payload: Record<string, unknown>;
  is_read: boolean;
  student: { id: number; name: string } | null;
  res_model: string | null;
  res_id: number | null;
  create_date: string | null;
}

export async function listNotifications(options?: {
  is_read?: boolean;
  limit?: number;
}): Promise<CenterNotification[]> {
  const params: Record<string, string | number> = {};
  if (options?.is_read !== undefined) {
    params.is_read = options.is_read ? 'true' : 'false';
  }
  if (options?.limit !== undefined) {
    params.limit = options.limit;
  }
  const { data } = await client.get<CenterNotification[]>(
    '/api/v1/notifications',
    { params }
  );
  return data;
}

export async function getUnreadCount(): Promise<number> {
  const { data } = await client.get<{ count: number }>(
    '/api/v1/notifications/unread-count'
  );
  return data.count;
}

export async function markNotificationRead(
  id: number
): Promise<CenterNotification> {
  const { data } = await client.post<CenterNotification>(
    `/api/v1/notifications/${id}/read`
  );
  return data;
}
